module.exports = __webpack_public_path__ + "static/media/chair-selected.43c07a1c.png";